import { builtinNames } from '@crown/dsl-compiler';

/** Built once: the engine's list does not change while the process runs. */
let knownNames: Set<string> | null = null;

/**
 * Every name a rule can call, as a lookup.
 *
 * Asked of the engine rather than kept here. A second list of what the language
 * has is a list that falls behind - a builtin added in Rust would be reported
 * as an unknown function by the editor, and refused by the SQL translator, for
 * as long as nobody remembered to add it in two places.
 */
export function knownFunctionNames(): Set<string> {
  knownNames ??= new Set(builtinNames());
  return knownNames;
}
